import { render } from "./SheetEmergencyCode.vue?vue&type=template&id=6dca7aab"
import script from "./SheetEmergencyCode.vue?vue&type=script&lang=js"
export * from "./SheetEmergencyCode.vue?vue&type=script&lang=js"
script.render = render

export default script